import { render, staticRenderFns } from "./VirtualPos.vue?vue&type=template&id=1e2104e6"
import script from "./VirtualPos.vue?vue&type=script&lang=js"
export * from "./VirtualPos.vue?vue&type=script&lang=js"
import style0 from "./VirtualPos.vue?vue&type=style&index=0&id=1e2104e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports